<script lang="ts">
    export let selected: boolean;
    export let selectedColor: string;
</script>

<div class="w-5 {selected ? selectedColor : 'stroke-neutral-700 group-hover:stroke-accent'} transition-colors">
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
        <rect x="-0.5" y="0.5" width="10" height="16" transform="matrix(-1 0 0 1 16 0)" />
        <path d="M12 8H1" />
        <path d="M4 5L1 8.00001L4 11" />
    </svg>
</div>
